

import React, { memo } from 'react';
import { FormModal, Text } from '../../../../../ui-kit';
import VoiceOverItem from './VoiceOverItem';
import getBillingRegionPrice from '../constants/getBillingRegionPrice';
import VoiceOverModalV3Content from './VoiceOverModalV3Content';
import '../styles/_voice-over-modal.scss';









function getVoiceOverItems() {
  return [
  { id: 0, duration: 'Up to 1 minute', wordsCount: 'or 150 words' },
  { id: 1, duration: 'Up to 2 minutes', wordsCount: 'or 300 words' },
  { id: 2, duration: 'Up to 5 minutes', wordsCount: 'or 750 words' },
  {
    id: 3,
    duration: 'Over 5 minutes',
    wordsCount: null,
    priceStr: 'Speak to us'
  }];

}

function getVoiceOverItemPrice(
price,
billingCode,
id,
priceVersion)
{
  return price || getBillingRegionPrice(billingCode, id, priceVersion);
}

function VoiceOverModal({
  onClose,
  visible,
  getBillingEntityCode,
  priceVersion,
  openHubSpotConversationsWidget
}) {
  const billingEntityCode = getBillingEntityCode && getBillingEntityCode();
  const isV3 = priceVersion === 'V3';
  return (
    <div className="voice-over-modal">
      <FormModal
        visible={visible}
        title={`${isV3 ? 'Indicative ' : ''}Voice Over Rate Card`}
        onClose={onClose}
        closeText="Close"
        closeBtnType="PRIMARY">

        <div className="voice-over-modal__content">
          {isV3 ?
          <VoiceOverModalV3Content /> :

          <>
              <Text body noMargin className="voice-over-modal__subtitle">
                The below rates are indicative only. You will be contacted to
                confirm costs based off your brief and usage type before we
                proceed.
              </Text>
              <Text body noMargin>
                A Voice Over may add up to 48 hours to your turnaround time.
              </Text>
            </>}


          {billingEntityCode &&
          <div className="voice-over-modal__items">
              {getVoiceOverItems().map((option) =>
            <VoiceOverItem
              key={option.id}
              duration={option.duration}
              wordsCount={option.wordsCount}
              priceStr={getVoiceOverItemPrice(
                option.priceStr,
                billingEntityCode,
                option.id,
                priceVersion
              )}
              openHubSpotConversationsWidget={
              openHubSpotConversationsWidget} />


            )}
            </div>}

        </div>
      </FormModal>
    </div>);

}

export default memo(VoiceOverModal);